export default {
      id: "ic_watch_stack_circle_filled_with_text-usage",
      viewBox: "0 0 30 15",
      url: "/" + "images/icons.3.109.2.svg#ic_watch_stack_circle_filled_with_text-usage",
      toString: function () {
        return this.url;
      }
    }